// src/reducers/snackbarSlice.js
import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  open: false,
  error: null,
  severity: '',
};

// Snackbar Slice
const snackbarSlice = createSlice({
  name: 'snackBar',
  initialState,
  reducers: {
    showSnackBar: (state, action) => {
      const { message, severity, open } = action.payload;
      state.open = open;
      state.error = message ?? null;
      state.severity = severity ?? '';
    },
  },
});

// Export actions and reducer
export const { showSnackBar } = snackbarSlice.actions;
export default snackbarSlice.reducer;